import { useEffect, useRef } from 'react';

export const useEffectOnlyOnUpdate = (callback: Function, deps: any[]): void => {
    const isMount = useRef(true);

    useEffect(() => {
        if (isMount.current) {
            isMount.current = false;
        } else {
            return callback();
        }
    }, deps);
};

export const useEffectOnlyOnMount = (callback: Function): void => {
    useEffect(() => {
        return callback();
    }, []);
};
